import { render, staticRenderFns } from "./WriteOffs.vue?vue&type=template&id=46784b72&scoped=true&"
import script from "./WriteOffs.vue?vue&type=script&lang=js&"
export * from "./WriteOffs.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffs.vue?vue&type=style&index=0&id=46784b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46784b72",
  null
  
)

export default component.exports